import { render, staticRenderFns } from "./sourceInfo.vue?vue&type=template&id=70ac3c78&scoped=true&"
import script from "./sourceInfo.vue?vue&type=script&lang=js&"
export * from "./sourceInfo.vue?vue&type=script&lang=js&"
import style0 from "./sourceInfo.vue?vue&type=style&index=0&id=70ac3c78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ac3c78",
  null
  
)

export default component.exports